import React from 'react';
import { ErrorMessageContent } from '../ErrorMessage/ErrorMessageContent';

export const ContactUsMessageContent = () => {

  return (
    <ErrorMessageContent
      title="Contáctenos"
      message="Lo atenderemos de inmediato."
    />
  );
};

export default React.memo(ContactUsMessageContent);
